module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('a', {
    attrs: {
      "href": "#/Aknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("1.Lupton")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#S1"
    }
  }, [_vm._v("Chief Yellowhorse Trading Post")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter2#C2"
    }
  }, [_vm._v("2. Allentown")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter2#S2"
    }
  }, [_vm._v("Cronemeyer Trading Post")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter3#C3"
    }
  }, [_vm._v("3. Houck")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter3#S3"
    }
  }, [_vm._v("Fort Courage")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter3#S4"
    }
  }, [_vm._v("Abandoned Querino Canyon Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Sanders")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#S5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Log Cabin Trading Post")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Holbrook")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curse of the Petrified Forest")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Painted Desert Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Navajo County Courthouse")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bucket of Blood Saloon")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blevins House")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wigwam Village Motel")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Joseph City")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#S12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ella’s Frontier Trading Post")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Winslow")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#S13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leorena Shipley: Ghost of the Cottonwood Wash")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#S14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("La Posada Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#S15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bojo’s Grill & Sports Club")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#S16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winslow Theater")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#S17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Earl’s Route 66 Motor Court")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Meteor City")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#S18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wicked Witch of Route 66")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#S19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mystical Meteor Crater")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Two Guns")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#S20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desert Zoo")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#S21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apache Death Cave")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Winona")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#S22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walnut Canyon “Ghost Bridge”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#C11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Flagstaff")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#S23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Riordan Mansion")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#S24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lowell Observatory")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#S25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Shantytown")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#S26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hotel Monte Vista")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#S27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orpheum Theatre")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#S28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milligan Home")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#S29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Weatherford Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#S30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Museum Club")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12#C12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Bellemont")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12#S31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Termansen Ranch")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#C13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Williams")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#S32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fray Marcos Harvey House and Train Depot")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#S33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twisters Soda Fountain")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#S34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sultana Bar")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#S35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simplicio Torrez’s Ghost")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#S36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Garter Bed and Bakery")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#S37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hatchet Murder of Hazel Johnson")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14#C14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Ash Fork")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14#S38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Curse of Ash Fork Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15#C15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Seligman")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15#S39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jas. A. Pitts Mercantile")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16#C16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Peach Springs")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16#S40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grand Canyon Caverns and Bunk House")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16#S41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harvey Hudspeth’s Foreboding Dream")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17#C17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Truxton")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17#S42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frontier Motel and Café")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter18#C18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Valentine")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter18#S43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Truxton Canyon Indian School")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter19#C19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Hackberry")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter19#S44",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Giganticus Headicus")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter19#S45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Superstition of the “Wallapai”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter20#C20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Kingman")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter20#S46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hotel Brunswick")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter20#S47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lee Williams High School")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter20#S48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("El Trovatore Motel")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter21#C21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Oatman")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter21#S49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oatman Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter21#S50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oatman’s “Pearl”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter22#C22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Topock")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter22#S51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Trails Arch Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/ParanormalResources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paranormal Resources: Teams and Tours")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0